import { Skeleton, SkeletonBlock, SkeletonContent, SkeletonLine, } from '@one-thd/sui-atomic-components';
import React from 'react';
export var TableSkeleton = function () {
    return (React.createElement(React.Fragment, null, Array(4)
        .fill(true)
        .map(function (__, i) { return (React.createElement("div", { key: i, className: "sui-pt-4", style: {
            border: '1px solid #CCCCCB',
            width: '1039px',
            paddingLeft: '48px',
        } },
        React.createElement(Skeleton, { disablePadding: true, orientation: "horizontal", style: { display: 'flex' } },
            React.createElement(SkeletonContent, { disablePadding: true, initialSize: "full", style: { maxWidth: '50px', height: '50px' } },
                React.createElement(SkeletonBlock, null)),
            React.createElement(SkeletonContent, { disablePadding: true, initialSize: "full", style: {
                    width: '900px',
                    height: '50px',
                    marginLeft: '65px',
                } },
                React.createElement(SkeletonLine, { variant: "single" }),
                React.createElement(SkeletonLine, { variant: "single" }))))); })));
};
